import { render, staticRenderFns } from "./productDetailSeckill.vue?vue&type=template&id=1bb21106&scoped=true"
import script from "./productDetailSeckill.vue?vue&type=script&lang=js"
export * from "./productDetailSeckill.vue?vue&type=script&lang=js"
import style0 from "./productDetailSeckill.vue?vue&type=style&index=0&id=1bb21106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb21106",
  null
  
)

export default component.exports